var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiper",staticClass:"swiper"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),(_vm.hasPagination)?_c('div',{ref:"pagination",staticClass:"swiper-pagination"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }